<template>
  <div class="Chatroom" ref="panel">
    <van-nav-bar :title="title" fixed border @click-left="onClickLeft" @click-right="onClickRight">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
      <template #right v-if="userinfo.u_type == 2">
        <img
          class="more"
          style="width:40px;height:40px;margin-top:-5px;"
          src="../../assets/img/icon/linekefu.png"
          alt
        />
      </template>
    </van-nav-bar>
    <van-popup class="service" v-model="serviceShow" overlay-class="over1">
      <p
        class="friends"
        v-for="(item,index) in List"
        :key="index"
        @click="selectService(item.u_id)"
      >{{item.u_nickname?item.u_nickname:item.u_name?item.u_name:item.u_login_id}}</p>
    </van-popup>
    <van-pull-refresh v-model="isloading" @refresh="reloadMoreMsg">
      <div id="content" ref="ref_content" :style="{height:scrollerHeight}">
        <audio :src="musicUrl" ref="msgaudio"></audio>
        <div :style="{'display':videoshow==true?'block':'none'}">
          <video :src="videoUrl" ref="msgvideo" style="width:200px;height:160px;" preload="auto"></video>
        </div>
        <!-- <van-loading v-if="videoFlag==true" type="spinner" color="#1989fa" /> -->
        <template v-for="(item,index) in chatMessage">
          <div :ref="'ref_msg_1'+item.m_id">
            <div v-if="item.m_type=='notice'" class="notice-content">{{item.m_post_messages}}</div>
            <!-- 右对齐 -->
            <van-row
              id="mycheck"
              type="flex"
              justify="end"
              v-if="userinfo.u_type==2?(item.m_from_user_id != friend_id):(item.m_from_user_id == u_id) && item.m_type!='notice'"
              :key="index+'a'"
              @click.stop="selectOption(item.m_id,item.m_from_user_id,item.create_time,item.m_type,item.m_post_messages,item.duration)"
            >
              <div :class="{'msg-box':flag}" :ref="'ref_msg_'+item.m_id">
                <van-image
                  class="err-image-header"
                  round
                  width="45px"
                  height="45px"
                  :src="attach_url+item.u_headportrait"
                />
                <van-col>
                  <div class="van-div-right">
                    <span class="time">{{item.create_time*1000|moment_format('M-D HH:mm')}}</span>
                  </div>
                  <div
                    :class="item.m_type=='video' || item.m_type == 'image' ?'entryimg2':'entry2'"
                  >
                    <div class="entry-trangle-right">
                      <!--本Div只来实现三角形，无其他作用-->
                    </div>
                    <span
                      v-if="item.m_type=='text'"
                      :class="[isUrl(item.m_post_messages) == true? 'span-url span-content':'span-content']"
                      :style="{'font-size':(WindValue+'px'),'line-height':(WindValue+6+'px')}"
                      v-html="analyzeEmoji(item.m_post_messages)"
                      @click="CheckUrl(item.m_post_messages)"
                    ></span>
                    <span
                      v-if="item.m_type=='audio'"
                      class="span-content"
                      :style="{width:parseInt(item.duration/1000)*2+50+'px'}"
                      @click.stop="playaudio(attach_url+item.m_post_messages,item.m_id)"
                    >
                      <div class="audio" style="text-align:right;">
                        <span>{{parseInt(item.duration/1000)}}"</span>
                        <img
                          style="transform: rotate(180deg);"
                          :id="item.m_id"
                          src="../../assets/img/center/pause.png"
                          alt
                        />
                      </div>
                    </span>
                    <span
                      v-if="item.m_type == 'video'"
                      class="span1-content"
                      @click.stop="playVideo(attach_url+item.m_post_messages,item.m_id)"
                    >
                      <div class="video-box">
                        <img
                          class="videocover"
                          :src="attach_url+item.m_post_messages.replace('mp4', 'jpg')"
                          style="height:140px;width:90px;"
                          alt
                        />
                        <div class="video-img"></div>
                        <span class="duration">{{parseInt(item.duration)}}"</span>
                      </div>
                    </span>
                    <van-image
                      v-if="item.m_type == 'image'"
                      class="err-image-img"
                      width="100"
                      :src="attach_url+item.m_post_messages"
                      @click.stop="showImage(attach_url+item.m_post_messages)"
                    />
                  </div>
                </van-col>
              </div>
              <input
                type="checkbox"
                v-show="select"
                :value="index"
                id="myCheck"
                v-model="selectArr"
                @click.stop
                :checked="checked==item.m_id"
              />
            </van-row>
            <!-- 左对齐 -->
            <van-row
              :class="select==true?'selectmore1':''"
              type="flex"
              justify="start"
              v-if="item.m_from_user_id == friend_id && item.m_type!='notice'"
              :key="index+'a'"
              @click="selectOption(item.m_id,item.m_from_user_id,item.create_time,item.m_type,item.m_post_messages,item.duration)"
            >
              <div :class="{'msg-box':flag}" :ref="'ref_msg_'+item.m_id">
                <van-image
                  round
                  width="45px"
                  height="45px"
                  style="float:left"
                  class="err-image-header"
                  :src="attach_url+item.u_headportrait"
                  @click="headPortrait(item.u_id)"
                />
                <van-col>
                  <div class="van-div-left">
                    <span class="time">{{item.create_time*1000|moment_format('M-D HH:mm')}}</span>
                  </div>
                  <div
                    :class="item.m_type=='video' || item.m_type == 'image' ?'entryimg2':'entry1'"
                  >
                    <!--本Div只来实现气泡三角形，无其他作用-->
                    <div class="entry-trangle-left"></div>
                    <span
                      v-if="item.m_type=='text'"
                      :class="[isUrl(item.m_post_messages) == true? 'span-url span-content':'span-content']"
                      :style="{'font-size':(WindValue+'px'),'line-height':(WindValue+6+'px')}"
                      v-html="analyzeEmoji(item.m_post_messages)"
                      @click="CheckUrl(item.m_post_messages)"
                    >{{item.m_post_messages}}</span>
                    <span
                      v-if="item.m_type=='audio'"
                      class="span-content"
                      :style="{width:parseInt(item.duration/1000)*2+50+'px'}"
                      @click.stop="playaudio(attach_url+item.m_post_messages,item.m_id)"
                    >
                      <img :id="item.m_id" src="../../assets/img/center/pause.png" alt />
                      <span>{{parseInt(item.duration/1000)}}"</span>
                    </span>
                    <span
                      v-if="item.m_type == 'video'"
                      class="span1-content"
                      @click.stop="playVideo(attach_url+item.m_post_messages,item.m_id)"
                    >
                      <div class="video-box">
                        <img
                          class="videocover"
                          :src="attach_url+item.m_post_messages.replace('mp4', 'jpg')"
                          style="height:140px;width:90px;"
                          alt
                        />
                        <div class="video-img"></div>
                        <span class="duration">{{parseInt(item.duration)}}"</span>
                      </div>
                    </span>
                    <van-image
                      v-if="item.m_type == 'image'"
                      width="100"
                      class="err-image-img"
                      :src="attach_url+item.m_post_messages"
                      @click.stop="showImage(attach_url+item.m_post_messages)"
                    />
                  </div>
                </van-col>
              </div>
              <input
                type="checkbox"
                v-show="select"
                :value="index"
                id="myCheck"
                v-model="selectArr"
                @click.stop
              />
              <!-- :checked="checked==item.m_id" -->
            </van-row>
          </div>
        </template>
        <van-popup
          v-model="show1"
          class="overly"
          :overlay-style="{backgroundColor:'transparent' }"
          :style="{width:'120px'}"
        >
          <div @click="delmsg(m_id, m_from_user_id,create_time)">
            <p
              v-if="new Date().getTime() - create_time * 1000 < 120000 && m_from_user_id == u_id"
            >撤回</p>
            <p v-else>删除</p>
          </div>
          <div>
            <p
              v-if="m_type=='text'"
              @click="Copy(m_id,m_from_user_id,create_time,m_type,m_post_messages)"
            >复制</p>
            <p
              v-else-if="m_type=='image'&& platforms=='app'"
              @click.stop="downImg(attach_url+m_post_messages)"
            >保存到相册</p>
          </div>
          <p
            @click.stop="transMsg(m_id,m_from_user_id,create_time,m_type,m_post_messages,duration)"
          >转发</p>
          <p onclick="event.cancelBubble = true" @click.stop="choose(m_id)">多选</p>
          <p @click.stop="delAll()">清空记录</p>
        </van-popup>
      </div>
    </van-pull-refresh>
    <div
      class="bottom-bar"
      v-if="select"
      style="background-color:#fff;display:flex;justify-content:space-around;"
    >
      <div class="v1tabbar" style="background-color:#fff;" @click="transmit()">
        <img
          :disabled="isDisable"
          style="'width:18px;height:18px;vertical-align: middle;"
          class="face"
          src="../../assets/img/center/transpond.png"
        />
        <span style="font-size:16px;">转发</span>
      </div>
      <div @click="delmore(m_id, m_from_user_id,create_time,m_post_messages)">
        <img
          :disabled="isDisable"
          style="'width:18px;height:18px;vertical-align: middle;"
          class="face"
          src="../../assets/img/center/delete.png"
        />
        <span style="font-size:16px;">删除</span>
      </div>
    </div>
    <div class="bottom-bar" v-else-if="platforms=='app'">
      <div class="v-tabbar">
        <img
          class="face"
          src="../../assets/img/icon/voice.png"
          @click="clickVoice(1)"
          v-if="voice == 0"
        />
        <img class="face" src="../../assets/img/icon/keybd.png" @click="clickVoice(0)" v-else />
        <div v-if="voice==1" class="voice">
          <van-button class="sendc" @click="handleBtnClick" v-show="!recordimg">开始录音</van-button>
          <van-popup v-model="recordimg" class="recordimg" :overlay="false">
            <img src="../../assets/img/center/record.gif" alt />
            <van-count-down
              ref="voiceCountDown"
              millisecond
              :time="voiceLimit"
              :auto-start="false"
              :format="voiceLimit>=60000?'mm:ss:SSS':'ss:SSS'"
              @finish="send_voice"
            />
          </van-popup>
          <van-button class="sendc" @click.stop="cancel_voice" v-show="recordimg">取消录音</van-button>
          <van-button class="sendc" @click.stop="send_voice" v-show="recordimg">发送</van-button>
        </div>
        <van-field
          v-else
          class="sendc"
          v-model="content"
          :clearable="true"
          border
          placeholder="请输入内容"
          type="textarea"
          autosize
          @click="showOf()"
          @focus="closeOther()"
        />
        <!-- @click-input="keyboard()" -->
        <img class="face" src="../../assets/img/icon/face.png" alt @click="showface()" />
        <van-button
          class="send"
          v-if="content!=''"
          :style="{ width: '20%'}"
          type="info"
          @click="sendmsg"
        >发送</van-button>
        <img class="face" v-else src="../../assets/img/icon/plus.png" @click="showFunction()" />
      </div>
      <div v-show="faceshow" class="faceshow">
        <van-icon
          size="8"
          v-for="item in OwOlist"
          :key="item+''"
          :name="getOwOlistUrl()+item.url"
          @click="selectOwO(item.title)"
        />
      </div>
      <div class="functionshow" v-show="functionshow">
        <button class="f-button">
          <van-icon size="35" name="photograph" @click="photo()" />
        </button>
        <van-uploader capture :after-read="onSend" :before-read="beforeRead" accept="image/*">
          <button class="f-button">
            <van-icon size="35" name="photo" @click="O()" />
          </button>
        </van-uploader>
        <button class="f1-button">
          <input
            ref="uploadVideo"
            type="file"
            @change="sendVideo"
            accept="video/*"
            id="fileUpload"
            capture="camcorder"
            style="opacity:0; width:35px;"
          />
          <!-- <input ref='videofile' id="selectvideo" type="file" name="file" @change="uploadVideo"  style="opacity:0; width:35px;"> -->
        </button>
      </div>
    </div>
    <div class="bottom-bar" v-else>
      <div class="v-tabbar">
        <van-field
          type="textarea"
          class="sendc"
          v-model="content"
          :clearable="true"
          :autosize="true"
          border
          placeholder="请输入内容"
          @click="showOf()"
          @focus="closeOther()"
          @keyup.ctrl.enter.native="onTextareaKeyDown()"
        />
        <img class="face" src="../../assets/img/icon/face.png" alt @click="showface()" />
        <van-button
          class="send"
          v-if="content!=''"
          :style="{ width: '20%'}"
          type="info"
          @click="sendmsg"
        >发送</van-button>
        <img class="face" v-else src="../../assets/img/icon/plus.png" @click="showFunction()" />
      </div>
      <div v-show="faceshow" class="faceshow">
        <van-icon
          size="8"
          v-for="item in OwOlist"
          :key="item+''"
          :name="getOwOlistUrl()+item.url"
          @click="selectOwO(item.title)"
        />
      </div>
      <div class="functionshow" v-show="functionshow">
        <button class="f-button">
          <van-icon size="35" name="photo" @click="photo()" />
        </button>
        <van-uploader capture :after-read="onSend" :before-read="beforeRead" accept="image/*">
          <button class="f-button">
            <van-icon size="35" name="photograph" @click="O()" />
          </button>
        </van-uploader>
        <button class="f1-button">
          <input
            ref="uploadVideo"
            type="file"
            @change="sendVideo"
            accept="video/*"
            id="fileUpload"
            capture="camcorder"
            style="opacity:0; width:35px;"
          />
        </button>
      </div>
    </div>
    <van-popup
      v-model="photoShow"
      closeable
      close-icon="close"
      position="bottom"
      :style="{ height: '45%' }"
    >
      <van-tabbar :fixed="false">
        <van-button type="primary" @click="filesSend">发送</van-button>
      </van-tabbar>
      <van-uploader
        v-model="fileList"
        :after-read="onRead"
        :before-read="beforeRead"
        accept="image/*"
        :style="{'margin-top': '15%'}"
        :max-count="1"
      />
    </van-popup>

    <!-- 声音提醒 -->
    <audio controls="controls" hidden src="./static/mp3/msg.wav" ref="altaudio"></audio>
    <van-dialog
      v-model="showImgDialog"
      :showConfirmButton="false"
      :closeOnClickOverlay="true"
      class="img_dialog"
      @click="showImgDialog=false"
    >
      <img :src="image_url" style="width:100%;" @click="showImgDialog=false" />
      <!-- @touchstart="start1()" -->
    </van-dialog>
  </div>
</template>
<script>
import { utf16toEntities, chkImgType, chkURL } from "@/utils/common.js";
import {
  OwOlistUrl,
  analyzeEmoji,
  emojiList,
  compUploadImg,
} from "@/utils/chat.js";
import Recorderx, { ENCODE_TYPE } from "recorderx";
const rc = new Recorderx();
export default {
	name: "Chatroom",
	data() {
		return {
			photoShow: false,
			recordimg: false,
			faceshow: false,
			show1: false,
			functionshow: false,
			textshow: false,
			popupVisible2: false,
			news_img: false,
			voice: false,
			active: 0,
			title: "",
			friend_id: "",
			fileList: [], // 回显图片
			imagePath: [], // 上传图片路径
			data: [],
			totalTime: 30,
			titleList: [{ name: "表情" }, { name: "多媒体" }],
			chatMessage: [],
			footHeight: 60,
			show: false,
			content: "",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			attach_url: this.Conf.serverPre,
			OwOlist: emojiList,

			connecting:false,
			voiceStartTime: null,
			refresh_more_time: 0,
			voiceLimit: 30000,
			filesizelimit: 10485760,
			minMsgId: 0,
			isloading: false,
			showImgDialog: false,
			image_url: "",
			platforms: null,
			showVideoDialog: false,
			video_url: "",
			Loop: 0,
			reloadMoreMsgFlag: false,
			img: "",
			flag: true,
			videoImg: "",
			imurl: "",
			videoFlag: false,
			videoProgress: 0,
			m_id: "",
			m_from_user_id: "",
			create_time: "",
			userinfo: JSON.parse(localStorage.getItem("userInfo")),
			chatList: [],
			maxMsgId: 0,
			WindValue: localStorage.getItem("fontsize")
			? parseInt(localStorage.getItem("fontsize"))
			: 12,
			rannumber: 1,
			latestInterTmer: false,
			longClick: 0,
			timeOutEvent: 0,
			m_post_messages: "",
			m_type: "",
			transfer: false,
			transtat: "",
			checkValue: "",
			select: false,
			checked: 0,
			selectArr: [],
			checkId: [],
			transfer: false,
			subArr: [],
			audiostatus: "",
			isDisable: false,
			serviceShow: false,
			List: [],
			musicUrl: "",
			videoUrl: "",
			videoshow: false,
			duration: "",
			nextplay: "",
			msgshowList: JSON.parse(localStorage.getItem("msgshowLists")),
			scrollHeight: 0,
			bottomstatus: "",
			chkWebsocketTimer:false,
			  videoLengthLimit:20,
			  videoSizeLimit:10 * 1024 * 1024
		};
	},
	created() {
		this.getStateConfigs();
		this.chatMessage = [];
		var query = this.$route.query;
		this.friend_id = query.friend_id;
		this.title = query.friend_name;
		this.transtat = query.transtat;
		this.bottomstatus = query.bottomstatus;

		this.chkSocketState();

		this.loadData();
	},
	mounted() {
		
		this.platforms = this.Conf.platform;
		this.connecting = this.websocket.connected;
		setTimeout(() => {
		  this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
		}, 500);
	},
	computed: {
		// 滚动区高度
		// (业务需求：手机屏幕高度减去头部标题和底部tabbar的高度，当然这2个高度也是可以动态获取的)
		scrollerHeight: function () {
			return window.innerHeight - 40 - this.footHeight + "px";
		},
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
				if (confs.duration) {
				  this.voiceLimit =
					parseInt(confs.duration.values) * 1000;
				}
				if (confs.fileSize) {
					this.filesizelimit = parseInt(
						confs.fileSize.values
					);
				}
				if (confs.videoLength){
					this.videoLengthLimit = parseInt(confs.videoLength.values);
				}
				if (confs.videoSize){
					this.videoSizeLimit = parseInt(confs.videoSize.values);
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		// 滚动至聊天底部
		scrollToBottom() {
			// 滚动
			if (this.$refs.ref_content.scrollHeight > 0) {
				this.$nextTick(() => {
					this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
				});
			}
		},
		photo() {
			this.photoShow = true;
		},
		selectOption(m_id, m_from_user_id, create_time, m_type, m_post_messages, duration ) {
			if (this.select) {
				this.select = false;
				return;
			}
			this.m_id = m_id;
			this.m_from_user_id = m_from_user_id;
			this.create_time = create_time;
			this.m_post_messages = m_post_messages;
			this.m_type = m_type;
			this.duration = duration;
			// this.show1 = true;
			let that = this;
			clearTimeout(that.Loop);
				that.Loop = setTimeout(() => {
				that.Loop = 0;
				this.show1 = true;
			}, 500);
		},
		//清空所有聊天记录
		delAll() {
			this.show1 = false;
			this.$dialog
			.confirm({
				title: "清空记录",
				message: "确定清空所有聊天记录吗？",
			})
			.then(() => {
				var params = {
					m_id: "one",
					type: 1,
					friend_id: this.friend_id,
					u_id: this.u_id,
					token: this.token,
					num: Math.random(),
				};
				var url = this.Conf.serverUrl + "Friends/delMsg";
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then((response) => {
					switch (response.data.code) {
						case 200:
						  this.chatMessage = [];
						  break;
						case 40001:
						  this.$toast.fail("清空失败！");
						  break;
					}
				})
				.catch((error) => {});
			})
			.catch(() => {});
			return false;
		},
		//批量删除
		delmore() {
			var that = this;
			this.isDisable = true;
			setTimeout(() => {
				that.isDisable = false;
			}, 1000);
			var len = that.chatMessage.length;
			for (var i = 0; i < len; i++) {
				if (this.selectArr.indexOf(i) >= 0) {
					that.subArr.push(that.chatMessage[i].m_id);
				}
			}
			if (that.subArr.length == 0) {
				this.$toast.fail("请选择要删除的数据");
			} else {
				this.$dialog
				.confirm({
					title: "删除消息",
					message: "确认删除该条消息吗？",
				})
				.then(() => {
					for (let c in that.subArr) {
						var params = {
							m_id: that.subArr[c],
							type: 1,
							u_id: this.u_id,
							token: this.token,
							num: Math.random(),
						};
						var url = this.Conf.serverUrl + "Friends/delMsg";
						if (this.userinfo.u_type == 2) {
							// 客服
							url = this.Conf.serverUrl + "Service/delMsg";
						}
						this.$axios
						.post(url, this.$qs.stringify(params))
						.then((response) => {
							switch (response.data.code) {
								case 200:
									var data = {
									m_id: that.subArr[c],
									friend_id: this.friend_id,
									u_id: this.u_id,
									mk: 9,
									};
									this.websocket.ws.send(JSON.stringify(data));
									//this.websocket.ws.onmessage = this.getMessage;
									break;
								case 40001:
									this.$toast.fail("删除失败！");
									break;
							}
						})
						.catch((error) => {});
					}
				})
				.catch(() => {});
				return false;
			}
		},
		//单条删除
		delmsg(m_id, m_from_user_id, create_time) {
			if (!this.websocket.connected) {
				return this.$toast("连接马上建立，请稍候...！");
			}
			this.show1 = false;
			if (new Date().getTime() - create_time * 1000 < 120000) {
				if (m_from_user_id == this.u_id) {
					this.$dialog
					.confirm({
					  title: "撤回消息",
					  message: "确定撤回该条消息吗？",
					})
					.then(() => {
						var params = {
							friend_id: this.friend_id,
							state: 1,
							m_id: m_id,
							u_id: this.u_id,
							token: this.token,
							num: Math.random(),
						};
						var url = this.Conf.serverUrl + "Friends/deleteOneMsg";
						if (this.userinfo.u_type == 2) {
							// 客服
							url = this.Conf.serverUrl + "Service/deleteOneMsg";
						}
						this.$axios
						.post(url, this.$qs.stringify(params))
						.then((response) => {
							switch (response.data.code) {
								case 200:
								  var data = {
									m_id: m_id,
									friend_id: this.friend_id,
									u_id: this.u_id,
									mk: 8,
								  };
								  this.websocket.ws.send(JSON.stringify(data));
								  break;
								case 40001:
								  this.$toast.fail("撤回失败！");
								  break;
							}
						})
						.catch((error) => {});
					})
					.catch(() => {});
				}
				return false;
			} else {
				this.$dialog
				.confirm({
					title: "删除消息",
					message: "确认删除该条消息吗？",
				})
				.then(() => {
					var params = {
						m_id: m_id,
						type: 1,
						u_id: this.u_id,
						token: this.token,
						num: Math.random(),
					};
					var url = this.Conf.serverUrl + "Friends/delMsg";
					if (this.userinfo.u_type == 2) {
						// 客服
						url = this.Conf.serverUrl + "Service/delMsg";
					}
					this.$axios
					.post(url, this.$qs.stringify(params))
					.then((response) => {
						switch (response.data.code) {
						case 200:
							var data = {
							  m_id: m_id,
							  friend_id: this.friend_id,
							  u_id: this.u_id,
							  mk: 9,
							};
							this.websocket.ws.send(JSON.stringify(data));
							break;
						case 40001:
							this.$toast.fail("删除失败！");
							break;
						}
					})
					.catch((error) => {});
				})
				.catch(() => {});
				return false;
			}
		},
		loadData(sts) {
			var params = {
				u_id: this.u_id,
				friend_id: this.friend_id,
				token: this.token,
				msg_id: sts==1?this.minMsgId:0,
				max_id: sts==2?this.maxMsgId:0,
			};
			var url = this.Conf.serverUrl + "Friends/chatroom";
			if (this.userinfo.u_type == 2) {
				url = this.Conf.serverUrl + "Service/serviceChatroom";
			}
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then((response) => {
				if (response.data.code == 200) {
					if (response.data.mk == 1) {
						for (var i in response.data.chatroomMsg) {
							this.chatMessage.push(response.data.chatroomMsg[i]);
							this.maxMsgId = response.data.chatroomMsg[i].m_id>this.maxMsgId?response.data.chatroomMsg[i].m_id:this.maxMsgId;
						}
					} else {
						for (var i in response.data.chatroomMsg) {
							response.data.chatroomMsg[i].status = false;
							this.chatMessage.unshift(response.data.chatroomMsg[i]);
							if (i == 0 && !this.maxMsgId) {
								this.maxMsgId = response.data.chatroomMsg[i].m_id;
								this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
							}
							this.minMsgId = (this.minMsgId==0||response.data.chatroomMsg[i].m_id<this.minMsgId)?response.data.chatroomMsg[i].m_id:this.minMsgId;
						}
					}
					// this.scrollToBottom();
					this.reloadMoreMsgFlag = false;
				}
			})
			.catch((error) => {});
		},
		//获取屏幕高度
		beforeMount() {
			const container = this.$refs.ref_content;
			var h = document.documentElement.clientHeight || document.body.clientHeight;
			container.scrollTop = h;
		},
		reloadMoreMsg() {
			this.footHeight = 60;
			if (!this.reloadMoreMsgFlag) {
				this.reloadMoreMsgFlag = true;
				setTimeout(() => {
					this.loadData(1);
					this.beforeMount();
					this.isloading = false;
				}, 2000);
			} else {
				this.isloading = false;
			}
			return true;
		},
		showface() {
			this.faceshow = true;
			this.functionshow = false;
			this.popupVisible2 = true;
			this.clickVoice(0);
			this.footHeight = 260;
			if (this.$refs.ref_content.scrollHeight > 0) {
				this.$nextTick(() => {
					this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
				});
			}
		},
		analyzeEmoji(cont) {
			return analyzeEmoji(cont);
		},
		onClickLeft() {
			// 返回
			this.$router.go(-1);
			var params = {
				u_id: this.u_id,
				token: this.token,
				num: Math.random(),
			};
			var url = this.Conf.serverUrl + "Friends/clearTempMId";
			if (this.userinfo.u_type == 2) {
				url = this.Conf.serverUrl + "Service/clearTempMId";
			}
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then((response) => {})
			.catch((error) => {});
		},
		// 获取在线客服（客服账号专用）
		onClickRight() {
			var params = {
				u_id: this.u_id,
				token: this.token,
				u_platform: this.userinfo.u_platform,
				num: Math.random(),
			};
			var url = this.Conf.serverUrl + "Service/getServiceInfos";
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then((response) => {
				switch (response.data.code) {
				case 200:
					this.serviceShow = true;
					this.List = response.data.serviceInfo;
					break;
				case 40001:
					this.$dialog
					.alert({
						message: response.data.msg,
					})
					.then(() => {
					  // on close
					});
					break;
			  }
			})
			.catch((error) => {});
		},
		// 选择转移客服
		selectService(service_id) {
			var params = {
				friend_id: this.friend_id,
				u_id: this.u_id,
				service_id: service_id,
				mk: 11,
			};
			this.websocket.ws.send(JSON.stringify(params));
			this.$router.push({ path: this.Conf.homeUrl });
		},
		// 监听socket消息回调
		getMessage(msg) {
			var that = this;
			var data = JSON.parse(msg.data);
			if (data && data.m_type == "alert") {
				that.$toast(data.m_post_messages);
				return;
			}

			switch (data.status) {
				case 1:
				case 2:
					// 重新连接socket fd改变，客户端与服务端token相等时，不退出登入
					if (that.token == data.token) {
						return;
					}
					// 用户在别处登录，客服端与服务端token不相等时
					// 客户端token 与 后台token不相等时，退出登入
					window.localStorage.clear();
					that.$dialog
					.alert({
						message: data.message,
					})
					.then(() => {
						that.$router.push({ path: "/login" });
					});
					break;
				case 3:
					if (data.tag == "one" && data.message == "deleteOk") {
						that.$refs["ref_msg_" + data.m_id][0].innerHTML = "撤回了一条消息";
						that.$refs["ref_msg_" + data.m_id][0].style.width = "100%";
						that.$refs["ref_msg_" + data.m_id][0].style.fontSize = "12px";
						that.$refs["ref_msg_" + data.m_id][0].style.color = "#969799";
						that.$refs["ref_msg_" + data.m_id][0].style.lineHeight = "40px";
						return;
					} else if (data.tag == "del" && data.message == "deleteOk") {
						that.$refs["ref_msg_1" + data.m_id][0].innerHTML = "";
						return;
					}
					// 只push到当前聊天
					if (
					(data.u_id == that.u_id && data.friend_id == that.friend_id) ||
					(data.u_id == that.friend_id && data.friend_id == that.u_id)
					) {
						if (that.transtat != 1) {
							that.chatMessage.push(data.data);
							// that.chatMessage.push(JSON.parse(JSON.stringify(data.data)));
						}
						that.transtat = "";
						setTimeout((_) => {
							if (that.$refs.ref_content.scrollHeight > 0) {
								that.$nextTick(() => {
									that.$refs.ref_content.scrollTop = that.$refs.ref_content.scrollHeight;
								});
							}
						}, 500);
					}
					if (data.tag == "group" && data.data.gm_from_id != that.u_id) {
						that.recordUnreadChat(data);
						//播放声音
						var groupNoDistrrbing = localStorage.getItem(
						  data.ug_id + "groupNoDistrrbing"
						);
						if (that.u_id != data.data.gm_from_id && groupNoDistrrbing != 1) {
							// console.log("当前chat播放音乐用户id：" + that.u_id);
							that.$refs.altaudio.currentTime = 0; //从头开始播放提示音
							that.$refs.altaudio.play(); //播放
						}
					}
					that.staticsMsgUnread();
					break;
				case 4:
					that.maxMsgId = data.m_id;
					break;
				case 6:
					that.websocket.recordUnreadShareLike();
					that.websocket.staticsShareUnread();
					break;
				case 7:
					that.websocket.recordUnreadShareComment(data);
					that.websocket.staticsShareUnread();
					break;
				case 99:
					that.$toast('你有一条新的'+data.message);
					break;
				default:
					break;
			 }
		},
		chkSocketState() {
			if ( this.websocket && this.websocket.ws && this.websocket.ws.readyState == 1 ) {
				// 监听消息回调
				this.connecting = true;
				this.websocket.ws.onmessage = this.getMessage;
				if (this.latestInterTmer) {
					clearInterval(this.latestInterTmer);
				}
			}else{
				this.connecting = false;
				this.loadLatestMsg();
			}
			this.chkWebsocketTimer && clearTimeout(this.chkWebsocketTimer)
			this.chkWebsocketTimer = setTimeout(() => {
				this.chkSocketState();
			}, 2000);
		},
		// 发送消息
		sendmsg() {
		  if (!this.websocket.connected) {
			return this.$toast("连接马上建立，请稍候...！");
		  }
		  if (
			this.content.trim() == "" ||
			this.content == null ||
			typeof this.content == "undefined"
		  ) {
			return this.$toast("输入不能为空！");
		  } else {
			var data = {
			  message: utf16toEntities(this.content),
			  friend_id: this.friend_id,
			  u_id: this.u_id,
			  // mk: 1, //     --------------------------------------------------------------------------------------------
			  type: "text",
			  u_headportrait: this.userinfo["u_headportrait"],
			  m_id: this.u_id + "_" + this.rannumber,
			};
			// ------------------------------------------------------客服账号专用请求接口----------------------------------
			if (this.userinfo["u_type"] == 2) {
			  data.mk = 5;
			} else {
			  data.mk = 1;
			}
			// ----------------------------------------------------------------------------------------------------------
			++this.rannumber;
			this.websocket.ws.send(JSON.stringify(data));
			this.content = "";
			setTimeout((_) => {
			  if (this.$refs.ref_content.scrollHeight > 0) {
				this.$nextTick(() => {
				  this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
				});
			  }
			}, 500);
		  }
		},
		onTextareaKeyDown() {
			if (event.keyCode == 13) {
				//如果按的是enter键 13是enter
				event.preventDefault(); //禁止默认事件（默认是换行）
				this.sendmsg(); //执行发送动作
			}
		},
		loadLatestMsg() {
			if (this.latestInterTmer) {
				clearInterval(this.latestInterTmer);
			}
			if (this.connecting) return;
			let that = this;
			this.latestInterTmer = setInterval(() => {
				that.loadData(2);
			}, 2000);
		},
		headPortrait(id) {
			this.$router.push({
				name: "UserInfo",
				query: {
					friend_id: id,
					url: "Chatroom",
					active: 0,
				},
			});
		},
		isUrl(val) {
			//var reg = /([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/|[wW]{3}.|[wW][aA][pP].|[fF][tT][pP].|[fF][iI][lL][eE].)[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;
			//return reg.test(val);
			return chkURL(val);
		},
		CheckUrl(m_post_messages) {
		  if (!this.isUrl(m_post_messages)) {
		  } else {
			if (window.plus) {
			  plus.runtime.openURL(m_post_messages);
			} else {
			  window.open(m_post_messages);
			}
			return;
		  }
		},
		// 弹出表情包
		showPopup(re) {
		  this.show = re;
		},
		showFunction() {
			this.functionshow = true;
			this.faceshow = false;
			this.clickVoice(0);
			this.footHeight = 140;
			if (this.$refs.ref_content.scrollHeight > 0) {
				this.$nextTick(() => {
					this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
				});
			}
		},
		// 获取表情包url前缀
		getOwOlistUrl() {
			return OwOlistUrl;
		},
		// 选择表情包
		selectOwO(title) {
			this.content += title;
		},
		showOf() {
			this.show = false;
			// this.footHeight = 260;
			if (this.$refs.ref_content.scrollHeight > 0) {
				this.$nextTick(() => {
					this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
				});
			}
		},
		closeOther() {
			this.functionshow = false;
			this.faceshow = false;
			this.footHeight = 60;
			if (this.$refs.ref_content.scrollHeight > 0) {
				this.$nextTick(() => {
					this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
				});
			}
		},
		// 切换语音软键盘
		clickVoice(e) {
			this.voice = e;
			if (e == 1) {
				this.show = false;
				this.faceshow = false;
				this.functionshow = false;
			}
			this.footHeight = 60;
		},
		//录制语音
		handleBtnClick() {
			let that = this;
			rc.start()
			.then(() => {
				that.voiceStartTime = new Date().getTime();
				that.recordimg = true;
				that.$refs.voiceCountDown.reset();
				that.$refs.voiceCountDown.start();
			})
			.catch((error) => {
				that.recordimg = false;
				this.$toast("获取麦克风失败,不能录音哦");
			});
		},
		cancel_voice() {
			this.recordimg = false;
			rc.clear();
		},
		// 发送语音
		send_voice() {
		  if (!this.recordimg) return;
		  if (!this.websocket.connected) {
			return this.$toast("连接马上建立，请稍候...！");
		  }
		  this.recordimg = false;
		  rc.pause();
		  let voiceTimes = new Date().getTime() - this.voiceStartTime;
		  // this.$toast.fail("没有音频资源");
		  let that = this;
		  var wav = rc.getRecord({
			encodeTo: ENCODE_TYPE.WAV,
			compressible: true,
		  });
		  var formData = new window.FormData();
		  formData.append("audio", wav, Date.parse(new Date()) + ".wav");
		  let headers = { "Content-Type": "multipart/form-data" };
		  //  this.$axios.defaults.withCredentials = true;
		  var url =
			this.Conf.serverUrl + "Chat/uploadAudio" + "?num=" + Math.random();
		  this.$axios
			.post(url, formData, headers)
			.then((response) => {
			  if (response.data.audioUrl) {
				var data = {
				  message: response.data.audioUrl,
				  friend_id: that.friend_id,
				  u_id: that.u_id,
				  // mk: 1, ---------------------------------------------------------------------
				  type: "audio",
				  duration: voiceTimes,
				  u_headportrait: that.userinfo["u_headportrait"],
				  m_id: that.u_id + "_" + that.rannumber,
				};
				// ------------------------------------------------------客服账号专用请求接口----------------------------------
				if (this.userinfo["u_type"] == 2) {
				  data.mk = 5;
				} else {
				  data.mk = 1;
				}
				// ----------------------------------------------------------------------------------------------------------
				++that.rannumber;
				this.websocket.ws.send(JSON.stringify(data));
			  }
			  rc.clear();
			})
			.catch((err) => {});
		},
		//上传视频
		sendVideo() {
		  if (!this.websocket.connected) {
			return this.$toast("连接马上建立，请稍候...！");
		  }
		  var that = this;
		  let filesize = this.videoSizeLimit;
		  let filelength = this.videoLengthLimit;
		  var file = that.$refs.uploadVideo.files[0];
		  var formData = new FormData();
		  if (file.size > filesize) {
			that.$toast("视频不能超过" + filesize / (1024 * 1024) + "M");
			return;
		  } else if (file.length > filelength) {
			that.$toast("视频不能超过" + filelength + "s");
			return;
		  } else {
			that.$toast("请稍候...");
			formData.append("video", file);
			let headers = { "Content-Type": "multipart/form-data" };
			that.videoFlag = true;
			var url = this.Conf.serverUrl + "Chat/uploadVideo";
			that.$axios
			  .post(url, formData, headers)
			  .then((response) => {
				that.videoFlag = false;
				if (response.data.videoUrl) {
				  var userInfo = JSON.parse(localStorage.getItem("userInfo"));
				  var data = {
					message: response.data.videoUrl,
					duration: response.data.duration,
					friend_id: that.friend_id,
					u_id: that.u_id,
					// mk: 1, ---------------------------------------------------------------------------------------------
					type: "video",
					u_headportrait: that.userinfo["u_headportrait"],
					m_id: that.u_id + "_" + that.rannumber,
				  };
				  // ------------------------------------------------------客服账号专用请求接口----------------------------------
				  if (this.userinfo["u_type"] == 2) {
					data.mk = 5;
				  } else {
					data.mk = 1;
				  }
				  // ----------------------------------------------------------------------------------------------------------
				  ++that.ranmuber;
				  that.websocket.ws.send(JSON.stringify(data));
				}
			  })
			  .catch((err) => {});
		  }
		},
		playVideo(src, m_id) {
		  var that = this;
		  that.videoshow = true;
		  var video = that.$refs.msgvideo;
		  that.videoUrl = src;
		  if (video.paused) {
			that.FullSrceen();
			this.$nextTick(() => {
			  video.play();
			});
			video.addEventListener("ended", () => {
			  that.videoshow = false;
			  video.load();
			  that.exitFullscreen();
			});
			document.addEventListener("fullscreenchange", function (e) {
			  if (document.fullscreenElement) {
				video.play();
			  } else {
				that.videoshow = false;
				video.pause();
				// video.load();
			  }
			});
			document.addEventListener("webkitfullscreenchange", function (e) {
			  const isFullScreen =
				document.fullscreenEnabled ||
				window.fullScreen ||
				document.webkitIsFullScreen ||
				document.msFullscreenEnabled;
			  if (isFullScreen) {
				video.play();
			  } else {
				that.videoshow = false;
				video.pause();
				// video.load();
			  }
			});
		  }
		},
		//进入全屏
		FullSrceen() {
			var video = this.$refs.msgvideo;
			if (video.requestFullscreen) {
				video.requestFullscreen();
			} else if (video.mozRequestFullScreen) {
				video.mozRequestFullScreen();
			} else if (video.webkitRequestFullScreen) {
				video.webkitRequestFullScreen();
			} else if (video.msRequestFullscreen) {
				video.msRequestFullscreen();
			} else {
				this.videoshow = false;
				video.play();
			}
		},
		//退出全屏
		exitFullscreen() {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.oRequestFullscreen) {
				document.oCancelFullScreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			}
		},
		// 上传之前检测图片类似返回true和false会影响到onRead函数
		beforeRead(file) {
			return chkImgType(file);
		},
		// 发送图片
		filesSend() {
			if (!this.websocket.connected) {
				return this.$toast("连接马上建立，请稍候...！");
			}
			if (typeof this.data.message == "undefined" || !this.data.message || this.data.message.trim() == "" ) {
				return this.$toast("不能为空！");
			} else {
				this.$toast("请稍候...");
				var url =
				  this.Conf.serverUrl + "Chat/uploadImg" + "?num=" + Math.random();
				this.$axios
				.post(url, this.$qs.stringify(this.data))
				.then((response) => {
					if (response.data.imageUrl) {
						this.data.message = response.data.imageUrl;
						this.data.duration = response.data.duration;
						// 先执行上传保存图片，返回图片保存的路径，然后再发送socket消息，发送的是图片路径。
						// ------------------------------------------------------客服账号专用请求接口----------------------------------
						if (this.userinfo["u_type"] == 2) {
							this.data.mk = 5;
						} else {
							this.data.mk = 1;
						}
						// ----------------------------------------------------------------------------------------------------------
						this.websocket.ws.send(JSON.stringify(this.data));
						this.data = {};
						this.fileList = [];
					} else if (response.data.msg) {
						this.$toast(response.data.msg);
					}
				})
				.catch((error) => {});
			}
			this.photoShow = false;
		},
		// 拍照上传图片
		onRead(file) {
			if (!this.websocket.connected) {
				return this.$toast("连接马上建立，请稍候...！");
			}
			let that = this;
			that.$toast("请稍候...");
			compUploadImg(file, function (f) {
				that.data = {
					message: file.content,
					friend_id: that.friend_id,
					u_id: that.u_id,
					//mk: 1, ----------------------------------------------------------------
					type: "image",
					u_headportrait: that.userinfo["u_headportrait"],
					m_id: that.u_id + "_" + that.rannumber,
				};
				++that.rannumber;
			});
		},
		// 上传图片
		async onSend(file) {
			if (!this.websocket.connected) {
				return this.$toast("连接马上建立，请稍候...！");
			}
			let that = this;
		  // 小于1MB的图片都缩小像素上传
			compUploadImg(file, function (f) {
				that.$toast("请稍候...");
				let data = {};
				data.message = file.content;
				data.friend_id = that.friend_id;
				data.u_id = that.u_id;
				data.mk = 1;
				data.type = "image";
				data.u_headportrait = that.userinfo["u_headportrait"];
				data.m_id = that.u_id + "_" + that.rannumber;
				++that.rannumber;
				var url =
				  that.Conf.serverUrl + "Chat/uploadImg" + "?num=" + Math.random();
				setTimeout(() => {
					that.$axios
					.post(url, that.$qs.stringify(data))
					.then((response) => {
						if (response.data.imageUrl) {
							data.message = response.data.imageUrl;
							data.duration = response.data.duration;
							// ------------------------------------------------------客服账号专用请求接口----------------------------------
							if (that.userinfo["u_type"] == 2) {
								data.mk = 5;
							} else {
								data.mk = 1;
							}
							// ----------------------------------------------------------------------------------------------------------
							that.websocket.ws.send(JSON.stringify(data));
						} else if (response.data.msg) {
							that.$toast(response.data.msg);
						}
					})
					.catch((error) => {});
				}, 500);
			});
		},
		showImage(img) {
			this.showImgDialog = true;
			this.image_url = img;
		},
		// 保存图片
		downImg(img) {
			if (!window.plus) return;
			var self = this;
			plus.gallery.save(
				(this.image_url = img),
				() => {
					return self.$toast("图片已保存到相册!");
				},
				() => {
					return self.$toast("保存失败，请重试!");
				}
			);
		},
		//复制信息
		Copy(m_id, m_from_user_id, create_time, m_type, m_post_messages) {
			if (m_type == "text") {
				let url = m_post_messages;
			} else if (m_type == "image") {
				let url = this.attach_url + "" + m_post_messages;
			}
			let oInput = document.createElement("input");
			if (m_type == "text") {
				oInput.value = m_post_messages;
			} else if (m_type == "image") {
				oInput.value = this.attach_url + "" + m_post_messages;
			}
			document.body.appendChild(oInput);
			oInput.select(); // 选择对象;
			document.execCommand("Copy"); // 执行浏览器复制命令
			this.$toast("复制成功");
			oInput.remove();
		},
		transMsg( m_id, m_from_user_id, create_time, m_type, m_post_messages, duration ) {
			this.$router.push({
				path: "/NewChat",
				query: {
					m_post_messages: m_post_messages,
					m_type: m_type,
					duration: duration,
					url: "Chatroom",
				},
			});
		},
		playaudio(src, m_id) {
			var that = this;
			that.musicUrl = src;
			var msgaudio = that.$refs.msgaudio;
			var nextsplaya = document.getElementById(this.nextplay);
			if (that.nextplay) {
				nextsplaya.src = require("../../assets/img/center/pause.png");
				msgaudio.pause();
				msgaudio.load();
			}
			that.nextplay = m_id;
			var playa = document.getElementById(m_id);
			if (msgaudio.paused) {
				setTimeout(() => {
				  msgaudio.play();
				}, 1000);
				playa.src = require("../../assets/img/center/play.gif");
				msgaudio.addEventListener("ended", function () {
				  playa.src = require("../../assets/img/center/pause.png");
				});
			} else {
				msgaudio.pause();
				playa.src = require("../../assets/img/center/pause.png");
				msgaudio.load();
			}
		},
		choose(m_id) {
			// this.checked = m_id;
			this.select = true;
			this.show1 = false;
		},
		transmit() {
			var that = this;
			this.isDisable = true;
			setTimeout(() => {
				that.isDisable = false;
			}, 1000);
			var len = that.chatMessage.length;
			for (var i = 0; i < len; i++) {
				if (this.selectArr.indexOf(i) >= 0) {
					that.subArr.push(that.chatMessage[i]);
				}
			}
			if (that.subArr.length == 0) {
				this.$toast.fail("请勾选后再转发");
			} else {
				this.$router.push({
					path: "/NewChat",
					query: {
						m_post_messages: that.subArr,
						url: "Chatroom",
					},
				});
			}
		}
	},
	beforeDestroy() {
		if (this.latestInterTmer) clearInterval(this.latestInterTmer);
		if (this.Loop) clearTimeout(this.Loop);
		if (window.timer) clearInterval(window.timer);
		if (this.chkWebsocketTimer) clearTimeout(this.chkWebsocketTimer);
	},
};
</script>
<style lang="less">
</style>




// WEBPACK FOOTER //
// src/components/Message/Chatroom.vue